import { Flex, Form, LoadingIcon } from "basis";
import { postHref } from "library/api";
import { useMutation } from "react-query";
import { FormContent } from "./FormContent";
import { getEncodedPinBlock } from "./utils";
import { parseSendOtpResponse } from "./validation";

const initialValues = {
  newPin: "",
  confirmPin: "",
};

function SetPinNewPin({ state, dispatch }) {
  const { sendOtpUrl, accountInfo, productId } = state;
  const sendOtpMutation = useMutation(
    ({ accountId }) =>
      postHref(sendOtpUrl, {
        account_id: accountId,
      }),
    {
      onSuccess: async (response, { newPin }) => {
        const responseData = parseSendOtpResponse(response.data);

        if (responseData === null) {
          dispatch({
            type: "INVALID_RESPONSE",
          });
        }

        const {
          accountToken,
          maskedMobileNumber,
          publicKey,
          rsaId,
          finalisePinChangeAction,
          resendOtpAction,
        } = responseData;
        const encodedPinBlock = await getEncodedPinBlock({
          newPin,
          accountToken,
          publicKey,
        });

        if (encodedPinBlock === null) {
          dispatch({
            type: "PIN_ENCODING_FAILED",
          });
        } else {
          dispatch({
            type: "OTP_SENT_AND_PIN_ENCODED",
            maskedMobileNumber,
            encodedPinBlock,
            rsaId,
            finalisePinChangeAction,
            resendOtpAction,
          });
        }
      },
      onError: () => {
        dispatch({
          type: "SEND_OTP_FAILED",
        });
      },
    },
  );

  if (accountInfo === null) {
    return (
      <Flex height="200" placeItems="center">
        <LoadingIcon size="medium" />
      </Flex>
    );
  }

  const onSubmit = ({ errors, values }) => {
    if (Object.keys(errors).length === 0) {
      const { newPin } = values;

      sendOtpMutation.mutate({
        accountId: accountInfo.accountId,
        newPin,
      });
    }
  };

  return (
    <Form initialValues={initialValues} onSubmit={onSubmit}>
      {({ state: formState, validateField }) => (
        <FormContent
          accountInfo={accountInfo}
          formValues={formState.values}
          validateField={validateField}
          sendOtpMutation={sendOtpMutation}
          productId={productId}
        />
      )}
    </Form>
  );
}

export { SetPinNewPin };
